import { render } from "./faqList.vue?vue&type=template&id=46e764e8&scoped=true"
import script from "./faqList.vue?vue&type=script&lang=js"
export * from "./faqList.vue?vue&type=script&lang=js"

import "./faqList.vue?vue&type=style&index=0&id=46e764e8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e764e8"]])

export default __exports__